import { PREDEFINED_TENANTS } from 'swag-common/constants/main-swag.constants';
const baseUrl = '/api/v1/order';
const isCustomInkPro = window.swag.tenant === PREDEFINED_TENANTS.CUSTOM_INK;
export const proceedOrderUrl = isCustomInkPro ? `${baseUrl}/proceed-custom-ink-pro` : `${baseUrl}/proceed-reseller`;

// Dynamic Tenant is not used in core SWAG therefore empty URL
export const getTenantOrdersUrl = '';
export const proceedDutyOrderUrl = `${baseUrl}/proceed-reseller-duty-order`;
export const proceedAdminUrl = `${baseUrl}/proceed-reseller-admin-order`;